exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wz_toolbar{background-color:var(--v-secondary-base);position:fixed;width:100%;z-index:100}", ""]);

// exports
